export default __webpack_public_path__ + "static/media/iPadSS11overlay.1f07a2e6.png";